<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <h6>Listado de Datos Indicadores</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Año" dense v-model="filtroanio">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-select dense v-model="filtroestado" :items="estado" label="Estado" item-text="detalle"
                                item-value="valor"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Descripción" dense v-model="filtrodescr">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Indicador" dense v-model="filtroindicador">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>

                        <v-col cols="6" sm="6" md="3">
                            <v-select dense v-model="filtroarea" :items="itemsarea" label="Área" item-text="detalle"
                                item-value="valor"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Responsable" dense v-model="filtroresp">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-select dense v-model="filtroprovdef" :items="provdef" label="Provisorio/Definitivo"
                                item-text="detalle" item-value="valor"></v-select>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-btn tile color="success" @click="cargarListado()">
                            <v-icon left> mdi-magnify </v-icon>
                            Buscar
                        </v-btn>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                :items-per-page="400" hide-default-footer :loading="loadtable"
                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                <template v-slot:item.estado="{ item }">
                    <v-btn v-if="item.provdef == ''" class="font-class-name2" color="red" dark>
                        {{ item.estado }}
                    </v-btn>
                    <v-btn v-if="item.provdef == 'Definitivo'" class="font-class-name2" color="green" dark>
                        {{ item.estado }}
                    </v-btn>
                    <v-btn v-if="item.provdef == 'Provisorio'" class="font-class-name2" color="yellow" dark>
                        {{ item.estado }}
                    </v-btn>
                </template>
                <template v-slot:item.ver="{ item }">
                    <v-icon small color="blue" class="mr-2" @click.stop="editarInforme(item)">
                        mdi-pencil
                    </v-icon>
                </template>
            </v-data-table>
            <EditarInforme :visible="showEditar" :codgral="editedItem.codgral" :periodo="editedItem.periodo"
                :descr="editedItem.descr" :anio="filtroanio" @close="showEditar = false">
            </EditarInforme>
        </v-app>
    </div>
</template>
<style scoped>
.font-class-name2 {
    font-size: 12px !important;
}

::v-deep .v-data-table .v-data-table__wrapper td {
    font-size: 12px !important;
    padding: 2px 4px !important;
}

::v-deep .v-data-table .v-data-table-header tr th {
    font-size: 12px !important;
    padding: 2px 4px !important;
}
</style>
<script>
import axios from "../../axios-auth.js";
// import VerInforme from "../Requisitos/Informe.vue";
import EditarInforme from "./Cargardatos.vue"
//import Visualizardocumentos from "../Requisitos/Visualizardocumentos.vue";
import moment from "moment";
export default {
    components: { EditarInforme },
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        filtroanio: moment().format("YYYY"),
        filtroarea: "",
        filtroresp: "",
        filtroprovdef: "",
        filtroestado: "",
        filtrodescr: "",
        filtroindicador: "",
        listado: [],
        estado: [{ detalle: "Cargadas", valor: "C" },
        { detalle: "Sin cargar", valor: "S" },
        { detalle: "Todas", valor: "" },
        ],
        itemsarea: [{ detalle: "Administración", valor: "Administración" },
        { detalle: "Comercial", valor: "Comercial" },
        { detalle: "Control de Gestión", valor: "Control de Gestión" },
        { detalle: "Fabricación", valor: "Fabricación" },
        { detalle: "Ingeniería", valor: "Ingeniería" },
        { detalle: "Personal", valor: "Personal" },
        { detalle: "SGI", valor: "SGI" },
        { detalle: "SSGG", valor: "SSGG" },
        { detalle: "Técnica y Desarrollo", valor: "Técnica y Desarrollo" },
        { detalle: "Todos", valor: "" },
        ],
        provdef: [{ detalle: "Provisorio", valor: "P" },
        { detalle: "Definitivo", valor: "D" },
        { detalle: "Todos", valor: "" },
        ],
        showInforme: false,
        showEditar: false,
        loadtable: false,
        headers: [
            {
                text: "Código",
                align: "center",
                sortable: false,
                value: "codgral",
            },
            { text: "Descripción", value: "descr", align: "center", sortable: false },
            { text: "Indicador", value: "indicador", sortable: false },
            { text: "Área", value: "sector", sortable: false },
            { text: "Responsable", value: "resp", align: "center", sortable: false },
            { text: "Estado", value: "estado", align: "center", sortable: false },
            { text: "Fecha", value: "fecha", align: "center", sortable: false },
            { text: "Provisorio/Definitivo", value: "provdef", align: "center", sortable: false },
            { text: "Cargar", value: "ver", align: "center", width: "5%", sortable: false },
        ],
    }),
    computed: {
        show: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        editarInforme(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },

        cargarListado() {
            this.loadtable = true;
            const estado = this.filtroestado;
            const descr = this.filtrodescr;
            const anio = this.filtroanio;
            const provdef = this.filtroprovdef;
            const resp = this.filtroresp;
            const indicador = this.filtroindicador;
            const sector = this.filtroarea;

            let self = this;
            axios
                .get("/Indicadores/ListadoIndicadoresDatos?", {
                    params: {
                        estado: estado,
                        descr: descr,
                        anio: anio,
                        provdef: provdef,
                        resp: resp,
                        indicador: indicador,
                        sector: sector,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                    console.log(self.listado)
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },
    },
};
</script>